import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { PRODUCT_URL } from "../shared/src/lib/shared";
import { ErrorHandlerService } from "./error-handler.service";

@Injectable({
    providedIn: 'root',
})
export class ProductSegmentService {

    private readonly PRODUCT_SEVICE_URL = `${PRODUCT_URL}`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    public getProductSegment(): Observable<any> {
        return this.http.get<any>(`${this.PRODUCT_SEVICE_URL}/product-segment/getAllActive`);
    }

}